import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";

interface Options {
	formId: number;

	year?: number;

	month?: number;

	userId?: string;

	storeId?: number;

	complete?: boolean;

	compliant?: boolean;

	enabled?: boolean;

	onSuccess?: (data: PreviousObservationForm[]) => void;
}

const fetchInstanceByFormId = async ({
	formId,
	userId,
	storeId,
	year,
	month,
	complete
}: Options) => {
	const url = "/observations/instances/all-versions/";

	const params = {
		observationform: formId,
		store: storeId,
		created_for: userId,
		year,
		month,
		complete
	};

	const { data } = await cmsClient.get<
		CMSPaginatedData<PreviousObservationForm>
	>(url, { params });

	return data.results;
};

const useFilterFormInstance = (options: Options) => {
	const {
		enabled = true,
		onSuccess,
		formId,
		userId,
		storeId,
		year,
		month,
		complete
	} = options;

	// Key on the actual server-affecting fields only. Including the full
	// `options` object dragged the freshly-allocated `onSuccess`
	// callback into the queryKey on every render, which made React
	// Query treat each render as a new query — defeating the cache and
	// triggering a refetch every time the parent re-rendered.
	return useQuery(
		[
			"previousObservationForm",
			{ formId, userId, storeId, year, month, complete }
		],
		() => fetchInstanceByFormId(options),
		{ enabled, onSuccess }
	);
};

export default useFilterFormInstance;
